import React from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-section brand">
          <div className="brand-header">
            <h3>OLD MACHINE MARKET(OLMC)</h3>
            <div className="accent-line"></div>
          </div>
          <p className="brand-tagline">
            India's Trusted Marketplace for Pre-Owned Machinery
          </p>
          <p className="brand-description">
            Verified listings with transparent pricing and real locations - all in one platform.
          </p>
          <div className="feature-highlights">
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Verified Listings</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Transparent Pricing</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Real Locations</span>
            </div>
          </div>
        </div>

        {/* Popular Categories */}
        <div className="footer-section">
          <h4>Popular Categories</h4>
          <ul>
            <li><a href="/category/packaging">Packaging Machinery</a></li>
            <li><a href="/category/textile">Textile Equipment</a></li>
            <li><a href="/category/food-processing">Food Processing</a></li>
            <li><a href="/category/construction">Construction Equipment</a></li>
            <li><a href="/category/plastic">Plastic Machinery</a></li>
            <li><a href="/category/metalworking">Metal Working</a></li>
          </ul>
        </div>

        {/* For Buyers */}
        <div className="footer-section">
          <h4>For Buyers</h4>
          <ul>
            <li><a href="/browse">Browse Machines</a></li>
            <li><a href="/verified">Verified Suppliers</a></li>
            <li><a href="/inspection">Quality Inspection</a></li>
            <li><a href="/financing">Financing Options</a></li>
            <li><a href="/logistics">Logistics Support</a></li>
            <li><a href="/support">Buyer Support</a></li>
          </ul>
        </div>

        {/* Contact & Company */}
        <div className="footer-section">
          <h4>Contact & Support</h4>
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <FaEnvelope className="contact-icon" />
              </div>
              <div className="contact-details">
                <span className="contact-label">Email</span>
                <span className="contact-value">support@oldmachinemarket.in</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <FaPhone className="contact-icon" />
              </div>
              <div className="contact-details">
                <span className="contact-label">Phone</span>
                <span className="contact-value">+91 9825457848</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <FaMapMarkerAlt className="contact-icon" />
              </div>
              <div className="contact-details">
                <span className="contact-label">Address</span>
                <span className="contact-value">Sohamtex engineers
                  A/19/8, road no.8, near jalaram weigh bridge, Udhna,udhyognagar, Surat-394210, India</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            <p>© {new Date().getFullYear()} OLD MACHINE MARKET — All Rights Reserved</p>
          </div>
          <div className="jetronix-credit">
            <p>
              Powered by <a href="https://www.jetronix.co.in/" target="_blank" rel="noopener noreferrer">
                <strong>JETRONIX</strong>
              </a> - Your Complete IT Solutions Partner
            </p>
          </div>

          <div className="legal-links">
            <a href="https://merchant.razorpay.com/policy/RgopbfeI0W8zDi/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
            <a href="https://merchant.razorpay.com/policy/RgopbfeI0W8zDi/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            <a href="https://merchant.razorpay.com/policy/RgopbfeI0W8zDi/refund" target="_blank" rel="noopener noreferrer">
              Cancellation & Refund Policy
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
}